module.exports = __webpack_public_path__ + "img/pesto-gnocchi-pan.da6dbe79.jpg";